export { CollectionBanner } from './CollectionBanner';
